
import { defineComponent } from "vue";
import router from "./router";
// import SnackbarApp from "@/components/appComponents/Snackbar.vue";
import store from "./store";
import UserToken from "./Utils/user-token";
import { SnackbarModel } from "./interfaces/app/snackbarModel";
export default defineComponent({
  name: "App",
  // components: { SnackbarApp },
  computed: {
    snackbar(): SnackbarModel {
      return store.getters["app/getSnackbar"];
    },
  },

   created(): void {
     if (UserToken()) {
       router.push({ name: "Services" });
     } else {
      //  router.push({ name: "Services" });
      router.push({ name: "Authentication" });
     }
   },
});
